module.exports = __webpack_public_path__ + "img/icon-advanced-active.b181dd3e.svg";